#import "../fragments/sales-document-template-fragment.graphql"

mutation UpdateSalesDocumentTemplate($input: SalesDocumentUpdateInput!) {
    salesDocumentUpdate(input: $input) {
        salesDocument {
            ...SalesDocumentTemplateFragment
        }
    }
}
